const authActionFormStyle = {
  recoverPassword: {
    marginBottom: "1rem",
  },
  text: {
    marginBottom: "0.5rem",
  },
  textButton: {
    paddingLeft: {
      xs: "0.25rem",
      sm: "0.75rem",
    },
    paddingRight: {
      xs: "0.25rem",
      sm: "0.75rem",
    },
  },
  submitButton: {
    margin: "1rem 0",
  },
  submitButtonWithoutPostfix: {
    marginBottom: "2rem",
  },
  termsOfServiceText: {
    fontSize: 12,
    textAlign: "center",
    marginTop: "0.5rem",
    marginBottom: "0.75rem",
  },
};
export default authActionFormStyle;
